var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cooldown-container"},[_c('Spinner'),_c('span',{staticClass:"timer"},[_vm._v(_vm._s(_vm.timeLeft + ' сек.'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }